import { render, staticRenderFns } from "./QualityFollowUps.vue?vue&type=template&id=32cd9c24&scoped=true&"
import script from "./QualityFollowUps.vue?vue&type=script&lang=js&"
export * from "./QualityFollowUps.vue?vue&type=script&lang=js&"
import style0 from "./QualityFollowUps.vue?vue&type=style&index=0&id=32cd9c24&lang=scss&scoped=true&"
import style1 from "./QualityFollowUps.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cd9c24",
  null
  
)

export default component.exports